module.exports = __webpack_public_path__ + "assets/img/banner04_m.3927db7b.png";